import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { CustomerProvider } from "@zillout/shared-components";
import { MetaPixelProvider } from "./contexts/MetaPixelContext";
import { theme } from "./theme";
import { AppRoutes } from "./routes";

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <CustomerProvider>
          <MetaPixelProvider>
            <Router>
              <AppRoutes />
            </Router>
          </MetaPixelProvider>
        </CustomerProvider>
      </ChakraProvider>
    </QueryClientProvider>
  );
}

export default App;
